/** Keeps digits and one decimal point, with at most two places after it. */
export const cleanMoney = (raw: string) => {
  const digits = raw.replace(/[^\d.]/g, '');
  const [whole, ...rest] = digits.split('.');
  if (rest.length === 0) return whole;
  return `${whole}.${rest.join('').slice(0, 2)}`;
};
